import React from "react";

const { Provider, Consumer } = React.createContext("vehicle");

export { Provider, Consumer };
